import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ManualOrderService } from 'src/app/core/services/api-services/manual-order.service';

@Component({
  selector: 'app-add-nursing-home-modal',
  templateUrl: './add-nursing-home-modal.component.html',
  styleUrls: ['./add-nursing-home-modal.component.scss'],
})
export class AddNursingHomeModalComponent implements OnInit {
  NursingHomeForm: FormGroup | any;
  locationId: any;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<AddNursingHomeModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public toastrService: ToastrService,
    private manualService: ManualOrderService // Inject UserService here
  ) {
    this.locationId = this.data.location;
  }

  ngOnInit(): void {
    this.initializeNote();
  }

  initializeNote() {
    this.NursingHomeForm = this.fb.group({
      server_location: [this.locationId, Validators.required],
      name: ['', Validators.required],
    });
  }

  submitForm() {
    if (this.NursingHomeForm.valid) {
      const payload = this.NursingHomeForm.value;

      console.log(payload);

      // Call UserService method to add user insurance
      this.manualService.CreateNursingHome(payload).subscribe(
        (res: any) => {
          if (res?.body?.success) {
            console.log('Nursing Home added successfully:', res);
            this.dialogRef.close();
            this.toastrService.success(res?.body?.message);
          }
        },
        (error: any) => {
          console.error('Error adding Nursing Home:', error);
          // Handle error
        }
      );
    } else {
      Object.keys(this.NursingHomeForm.controls).forEach((field) => {
        const control = this.NursingHomeForm.get(field);
        control.markAsTouched({ onlySelf: true });
      });
    }
  }
}
